import React from 'react';

function Impressum({ language, toggleLanguage, navigateTo }) {
  const content = {
    en: {
      title: 'Imprint',
      info: 'Information according to § 5 TMG',
      address: 'Waltraud Pfister-Bläske<br />atelier-wpb<br />Johann-Biersack-Straße 27b<br />82340 Feldafing',
      contact: 'Contact',
      contactInfo: 'Email: atelier.wpb.feldafing@gmail.com',
      responsible: 'Responsible for content',
      responsibleInfo: 'Waltraud Pfister-Bläske<br />atelier-wpb<br />Johann-Biersack-Straße 27b<br />82340 Feldafing',
      dispute: 'Consumer dispute resolution/Universal arbitration board',
      disputeInfo: 'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
      backToHome: 'Back to Home'
    },
    de: {
      title: 'Impressum',
      info: 'Angaben gemäß § 5 TMG',
      address: 'Waltraud Pfister-Bläske<br />atelier-wpb<br />Johann-Biersack-Straße 27b<br />82340 Feldafing',
      contact: 'Kontakt',
      contactInfo: 'E-Mail: atelier.wpb.feldafing@gmail.com',
      responsible: 'Redaktionell verantwortlich',
      responsibleInfo: 'Waltraud Pfister-Bläske<br />atelier-wpb<br />Johann-Biersack-Straße 27b<br />82340 Feldafing',
      dispute: 'Verbraucherstreitbeilegung/Universalschlichtungsstelle',
      disputeInfo: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
      backToHome: 'Zurück zur Startseite'
    }
  };

  return (
    <>
      <header>
        <div className="container header-container">
          <button 
            className="logo-button" 
            onClick={() => navigateTo('home', 'work')}
          >
            {language === 'en' ? 'atelier-wpb' : 'atelier-wpb'}
          </button>
          <nav>
            <ul>
              <li>
                <a 
                  href="/"
                  className="nav-link" 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    navigateTo('home', 'work');
                  }}
                >
                  {language === 'en' ? 'My Work' : 'Meine Arbeiten'}
                </a>
              </li>
              <li>
                <a 
                  href="/about" 
                  className="nav-link" 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    navigateTo('home', 'about');
                  }}
                >
                  {language === 'en' ? 'About' : 'Über Mich'}
                </a>
              </li>
              <li>
                <a 
                  href="/contact" 
                  className="nav-link" 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    navigateTo('home', 'contact');
                  }}
                >
                  {language === 'en' ? 'Contact' : 'Kontakt'}
                </a>
              </li>
            </ul>
            <button className="language-switch" onClick={toggleLanguage}>
              {language === 'en' ? 'DE' : 'EN'}
            </button>
          </nav>
        </div>
      </header>
      
      <section className="section-content">
        <div className="container">
          <h1>{content[language].title}</h1>
          <div className="legal-content">
            <h2>{content[language].info}</h2>
            <p dangerouslySetInnerHTML={{ __html: content[language].address }}></p>
            
            <h2>{content[language].contact}</h2>
            <p dangerouslySetInnerHTML={{ __html: content[language].contactInfo }}></p>
            
            <h2>{content[language].responsible}</h2>
            <p dangerouslySetInnerHTML={{ __html: content[language].responsibleInfo }}></p>
            
            <h2>{content[language].dispute}</h2>
            <p dangerouslySetInnerHTML={{ __html: content[language].disputeInfo }}></p>
            
            <div className="back-link">
              <button 
                className="link-button" 
                onClick={() => navigateTo('home', 'work')}
              >
                {content[language].backToHome}
              </button>
            </div>
          </div>
        </div>
      </section>
      
      {/* Footer excluded, as it's handled in App.js */}
    </>
  );
}

export default Impressum;
